import { Component } from '@angular/core';

@Component({
  selector: 'app-sed-events-table',
  templateUrl: './sed-events-table.component.html',
  styleUrl: './sed-events-table.component.scss',
  standalone: false,
})
export class SedEventsTableComponent {}
